export default {
  height: 'auto',
  // calcHeight: 100,
  tip: false,
  border: true,
  index: false,
  selection: false,
  viewBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuType: 'text',
  // menuWidth: 250,
  column: [
    {
      label: '主键',
      prop: 'id',
      hide: true,
      span: 8,
    },
    {
      label: '房间名称',
      prop: 'objectFullName',
    },
    {
      label: '房间代码',
      prop: 'objectCode',
    },
    {
      label: '房屋性质',
      prop: 'useType',
      dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=1',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '房屋状态',
      prop: 'roomStatus',
      hide: false,
      dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '户主名称',
      prop: 'householdName',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入户主名称',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '联系电话',
      prop: 'householdLinkPhone',
      width:120,
      rules: [
        {
          required: true,
          message: '请输入户主联系电话',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '上级属性',
    //   prop: 'parentObjectTypeName',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   readonly: true,
    //   span: 8,
    // },
    // {
    //   label: '本级属性',
    //   prop: 'objectType',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   viewDisplay: true,
    //   type: 'select',
    //   dataType: 'number',
    //   dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
    //   props: { label: 'dictValue', value: 'dictKey' },
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择上级节点',
    //       trigger: 'blur',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: '房间号',
    //   prop: 'objectName',
    //   hide: false,
    //   addDisplay: true,
    //   editDisplay: true,
    //   // search: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请输入节点名称',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: '速记码',
    //   prop: 'shortCode',
    //   hide: false,
    //   addDisplay: true,
    //   editDisplay: true,
    //   // search: true,
    //   span: 8,
    // },
    // {
    //   label: '排序序号',
    //   prop: 'indexNum',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请输入排序序号',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: '房产地址',
    //   prop: 'roomName',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请输入房屋地址信息',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 24,
    // },
    {
      label: '建筑面积',
      prop: 'floorage',
    },
    {
      label: '使用面积',
      prop: 'usableArea',
    },
    // {
    //   label: '户型',
    //   prop: 'roomLayout',
    //   hide: false,
    //   addDisplay: true,
    //   editDisplay: true,
    //   viewDisplay: true,
    //   type: 'select',
    //   dataType: 'number',
    //   dicUrl: 'api/blade-system/dict/dictionary?code=room_layout',
    //   props: { label: 'dictValue', value: 'dictKey' },
    //   span: 8,
    // },
    // {
    //   label: '阁楼面积',
    //   prop: 'loftArea',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       // required: true,
    //       message: '请输入阁楼面积',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: '朝向',
    //   prop: 'roomOrientations',
    //   type: 'select',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   viewDisplay: true,
    //   dataType: 'number',
    //   dicUrl: 'api/blade-system/dict/dictionary?code=room_orientations',
    //   props: { label: 'dictValue', value: 'dictKey' },
    //   span: 8,
    // },
    // {
    //   label: '用途',
    //   prop: 'useDesc',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       // required: true,
    //       message: '请输入房屋用途',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 16,
    // },

    // {
    //   label: '身份证',
    //   prop: 'householdIdCard',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       message: '请输入户主身份证',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: '邮箱',
    //   prop: 'householdEmail',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       message: '请输入户主邮箱',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
    // {
    //   label: 'QQ',
    //   prop: 'householdQQ',
    //   hide: true,
    //   addDisplay: true,
    //   editDisplay: true,
    //   rules: [
    //     {
    //       message: '请输入户主QQ',
    //       trigger: 'change',
    //     },
    //   ],
    //   span: 8,
    // },
  ],
};
